module.exports = __webpack_public_path__ + "static/media/29090028-DUg1wSgs.cd973aca.JPG";